import { Theme, makeStyles } from "../..";

export const useStyles = makeStyles<Theme>(() => ({
  iconButtonWithTooltip: () => ({
    background: "transparent",

    "& svg": {
      width: "1.15em",
      height: "1.15em",
    },

    "&:hover": {
      background: "transparent",
    },
  }),
}));
